exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".b-c[data-v-ebfb16a2]{color:#2675f1 !important}.search-item[data-v-ebfb16a2] input{border:1px solid rgba(255,255,255,0.2) !important}.common-table[data-v-ebfb16a2] .el-loading-mask{background-color:rgba(0,0,0,0.6)}.common-table[data-v-ebfb16a2] .el-loading-spinner .path{stroke:#2675f1}.common-table .o-btn[data-v-ebfb16a2]{width:1.39rem;height:0.44rem;border-radius:0.06rem;font-size:0.18rem;background:linear-gradient(264deg, #225bfc 0%, #062567 100%);cursor:pointer;color:#ffffff;border:0}\n", ""]);

// exports
